import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const discontinuarProductoF = createAsyncThunk(
  'productoForm/discontinuarProductoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.discontinuarProductoF,
        data
      );
      handleOKRequest(response, 'Producto discontinuado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al discontinuar el producto.'
      );
    }
  }
);
//Modificar de acuerdo a la lógica de la acción
export const actualizarProducto = createAsyncThunk(
  'productoForm/actualizarProducto',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.actualizarProducto,
        data
      );
      handleOKRequest(response, 'Producto actualizado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al actualizar el producto.'
      );
    }
  }
);
//Modificar de acuerdo a la lógica de la acción
export const verificarProducto = createAsyncThunk(
  'productoForm/verificarProducto',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.verificarProducto,
        data
      );
      handleOKRequest(response, 'Producto verificado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al verificar el producto.'
      );
    }
  }
);
